import { render, staticRenderFns } from "./usedDetail.vue?vue&type=template&id=04eeb222&scoped=true"
import script from "./usedDetail.vue?vue&type=script&lang=js"
export * from "./usedDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eeb222",
  null
  
)

export default component.exports